import { render } from "./MealManagement.vue?vue&type=template&id=ef3ecba0&scoped=true&ts=true"
import script from "./MealManagement.vue?vue&type=script&lang=ts"
export * from "./MealManagement.vue?vue&type=script&lang=ts"

import "./MealManagement.vue?vue&type=style&index=0&id=ef3ecba0&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3ecba0"]])

export default __exports__